import { useEffect, useState } from "react";
import { Reveal } from "../components/Reveal";
import { WEDDING_DATE } from "../lib/content";
import { useLang } from "../lib/i18n";

const calc = () => {
  const diff = Math.max(0, WEDDING_DATE - new Date());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    seconds: Math.floor(diff / 1000) % 60,
  };
};

export const Countdown = () => {
  const { c } = useLang();
  const [t, setT] = useState(calc);
  useEffect(() => {
    const i = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(i);
  }, []);

  return (
    <Reveal className="mt-24" delay={0.1}>
      <div className="border-y border-[#DFE4D0] py-12" data-testid="countdown-section">
        <p className="text-center font-serif-display italic text-2xl sm:text-3xl font-light mb-10">
          {c.countdown.title}
        </p>
        <div className="grid grid-cols-4 max-w-2xl mx-auto divide-x divide-[#DFE4D0]">
          {[
            ["days", t.days],
            ["hours", t.hours],
            ["minutes", t.minutes],
            ["seconds", t.seconds],
          ].map(([label, val]) => (
            <div key={label} className="text-center px-2" data-testid={`countdown-${label}`}>
              <div className="font-serif-display font-light text-4xl sm:text-6xl tabular-nums text-[#E15A70]">
                {String(val).padStart(2, "0")}
              </div>
              <div className="text-[10px] uppercase tracking-[0.3em] mt-3 text-[#2C3552]/50">{c.countdown[label]}</div>
            </div>
          ))}
        </div>
      </div>
    </Reveal>
  );
};
